import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Table, Row, Button, Popconfirm } from 'antd';
import { PopUpForm } from '../../../lib/ui/popupform';
import { showErrorInNotification, formatMoney } from '../../../lib/util';

const rules_cols = []

class BatcherReconcilerList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      other_recons: [],
      form_visibility: false,
      form_data: {}
    }

    this.list_exclusions = RESTExecutor.list().config({
      label: 'batcher_reconciler_list',
      params: {
        per_page: 10,
        batcher_group_id: this.props.batcher_id
      }
    }).callbacks(() => { }, (error) => {
      showErrorInNotification(error)
    }).forId(props.recon_id).connect(props.domains.batchergroup);


    this.post_exclusions = RESTExecutor.post().config({
      label: 'batcher_reconciler_list'
    }).forId(props.recon_id).callbacks((success) => {
      this.setState({
        form_visibility: false,
        form_data: {}
      })
      this.list_exclusions.execute();
    }).connect(props.domains.batchergroup);



    // this.list_other_reconcilers.execute();
    this.list_exclusions.execute();

    this.delete_exclusion = RESTExecutor.delete().config({
      label: 'batcher_reconciler_detail',
      params: {}
    }).callbacks((success) => {
      this.list_exclusions.config({
        per_page: 10, page: 1
      }).execute()
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.batchergroup);

  }

  render() {

    let list_exclusions_resp = this.list_exclusions.response();
    let list_exclusions_data = list_exclusions_resp.result || {};

    let post_exclusions_resp = this.post_exclusions.response();

    let rowsData = list_exclusions_data.rows || [];
    let rowsMeta = list_exclusions_resp.meta || {};

    const schema = [
      { index: 'reconciler_id', name: "Processor", type: 'networkselect', url: `/reconcilers?group_id=${this.props.group_id}`, filterable: true },
    ]

    return (
      <div>
        <PopUpForm
          width="60%"
          key={`${this.state.selected_id}upload`}
          title={"Batcher Processor"}
          show_title_only
          forCreate={true}
          initialData={this.state.form_data}
          fields={schema}
          open={this.state.form_visibility}
          networkState={post_exclusions_resp}
          onClose={() => {
            console.log("closing form")
            this.setState({
              form_visibility: false,
              form_data: {}
            })
          }
          }
          onSubmit={(data) => {
            console.log("DATA", data);

            this.post_exclusions.execute({ ...data, batcher_group_id: this.props.batcher_id });
          }}
        />

        <Table
          scroll={{ x: true }}
          dataSource={rowsData}
          className='ant-table-small-noborder customTable'
          loading={list_exclusions_resp.fetching}
          title={() => <Row type='flex' justify='space-between' style={{
            alignItems: 'center'
          }}><div></div>
            <Button type='primary' onClick={() => {
              this.setState({
                form_visibility: true,
              })
            }}>Add New</Button>
          </Row>}
          columns={[
            {
              title: "Processor", dataIndex: 'id', key: 'excluded_group_id', render: (id, data) => {
                let ref = data.__references__ || {};
                let group = ref.reconciler_id || {};
                return group.name;
              }
            },
            {
              title: "Batcher", dataIndex: 'reconciled', render: (id, data) => {
                let ref = data.__references__ || {};
                let group = ref.batcher_group_id || {};
                return group.name;
              }
            },
            {
              title: "", dataIndex: 'id', render: (id) => <span>
                <Popconfirm title="Are you sure you want to delete this item?" onConfirm={() => {
                  this.delete_exclusion.forId(id).execute();
                }}>
                  <Button type='link' style={{ color: 'red' }}>Delete</Button>
                </Popconfirm>
              </span>
            }
          ]}
          size='small'
          rowKey={(record) => record.id}
          pagination={{
            simple: false,
            position: 'bottom',
            onChange: (current, size) => {
              this.list_exclusions.config({
                params: {
                  per_page: size,
                  page: current,
                  batcher_id: this.props.batcher_id
                }
              }).execute();
            },
            defaultCurrent: 1,
            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
            // defaultPageSize: 20,
            pageSize: (rowsMeta && rowsMeta.requested_count),

            total: (rowsMeta && rowsMeta.total_count),
            showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
          }}
        />
      </div>
    );
  }
}

export default withDomains(BatcherReconcilerList, "settings", "batchergroup");
